var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-cascader",
    _vm._b(
      {
        ref: "cascader",
        attrs: {
          filterable: "",
          "group-field": "type",
          "railway-common-data-source": false
        },
        on: { input: _vm.onVisibleChange },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      },
      "cargo-cascader",
      _vm.params.selectProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }